import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "../lib/api";
import { useApp } from "../context/AppContext";
import PropertyCard from "../components/PropertyCard";
import Seo from "../components/Seo";

export default function SavedProperties() {
  const { saved } = useApp();
  const { data } = useQuery({
    queryKey: ["saved", saved],
    queryFn: async () => (await api.post("/properties/by-ids", { ids: saved.slice(0, 50) })).data,
    enabled: saved.length > 0,
  });
  // by-ids returns max 3; fetch individually is heavy — instead call list all and filter client-side
  const { data: all } = useQuery({ queryKey: ["all-for-saved"], queryFn: async () => (await api.get("/properties", { params: { limit: 100 } })).data, enabled: saved.length > 0 });
  const items = (all?.items || []).filter((p) => saved.includes(p.id));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <Seo title="Saved Properties | Faridabad Property Vault" />
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-slate-900 flex items-center gap-2"><Heart className="w-7 h-7 text-rose-500" fill="currentColor" /> Saved Properties</h1>
      <p className="text-slate-500 mt-1">Your shortlisted properties.</p>
      {items.length ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8" data-testid="saved-grid">{items.map((p) => <PropertyCard key={p.id} p={p} />)}</div>
      ) : (
        <div className="text-center py-24 bg-slate-50 rounded-2xl border border-dashed border-slate-200 mt-8">
          <p className="text-slate-600 font-semibold">No saved properties yet.</p>
          <Link to="/properties" className="text-indigo-800 font-semibold text-sm mt-2 inline-block">Explore properties →</Link>
        </div>
      )}
    </div>
  );
}
